import { PROVINCIAS_ES, PAISES_COMUN } from './spanishProvinces.js';

export { PAISES_COMUN };

/** En España la segunda lista son provincias / islas (división homogénea en desplegable). */
export const CIUDAD_OPTIONS_ES = [...PROVINCIAS_ES];

const CIUDAD_OPTIONS_OTROS = {
  PT: ['Lisboa', 'Porto', 'Braga', 'Coimbra', 'Faro', 'Aveiro', 'Setúbal', 'Guimarães', 'Viseu', 'Otra'],
  AD: ['Andorra la Vella', 'Escaldes-Engordany', 'Encamp', 'Sant Julià de Lòria', 'Otra'],
  IT: ['Roma', 'Milán', 'Nápoles', 'Turín', 'Florencia', 'Bolonia', 'Génova', 'Otra'],
  DE: ['Berlín', 'Hamburgo', 'Múnich', 'Colonia', 'Fráncfort', 'Stuttgart', 'Otra'],
  FR: ['París', 'Lyon', 'Marsella', 'Toulouse', 'Niza', 'Burdeos', 'Estrasburgo', 'Otra'],
  UK: ['Londres', 'Manchester', 'Birmingham', 'Glasgow', 'Edimburgo', 'Otra'],
  OT: ['Ubicación no listada'],
};

/** Barrios / zonas por provincia (España). Resto de provincias: opción genérica única. */
const LOCALIDADES_ES = {
  Madrid: [
    'Malasaña',
    'Chamberí',
    'Salamanca',
    'Centro',
    'Retiro',
    'Latina',
    'Carabanchel',
    'Chamartín',
    'Tetuán',
    'Puente de Vallecas',
    'Moratalaz',
    'Ciudad Lineal',
    'Hortaleza',
    'Moncloa — Aravaca',
    'Fuencarral — El Pardo',
    'Villaverde',
    'Vicálvaro',
    'Otro / no listado',
    '— No especificar —',
  ],
  Barcelona: [
    'Ciutat Vella',
    'Eixample',
    'Gràcia',
    'Sants — Montjuïc',
    'Sarrià — Sant Gervasi',
    'Sant Andreu',
    'Horta — Guinardó',
    'Les Corts',
    'Nou Barris',
    'Sant Martí',
    'Otro / no listado',
    '— No especificar —',
  ],
  Valencia: ['Ciutat Vella', 'Eixample', 'Extramurs', 'Campanar', 'Poblats Marítims', 'Otro', '— No especificar —'],
  Sevilla: ['Casco Antiguo', 'Triana', 'Los Remedios', 'Macarena', 'Nervión', 'Este — Alcosa', 'Sur', 'Otro', '— No especificar —'],
  Bizkaia: ['Bilbao — Casco Viejo', 'Indautxu', 'Deusto', 'Getxo', 'Barakaldo', 'Portugalete', 'Otro', '— No especificar —'],
  Málaga: ['Centro', 'Teatinos', 'Carretera de Cádiz', 'El Palo', 'Churriana', 'Otro', '— No especificar —'],
  Zaragoza: ['Casco viejo', 'Delicias', 'Universidad', 'Actur', 'Otro', '— No especificar —'],
};

const LOCALIDAD_DEFAULT_ES = ['— No especificar barrio —'];

const LOCALIDAD_EXTRANJERO = ['Centro urbano', 'Periferia', '— No especificar —'];

export function paisLabelToCode(paisLabel) {
  if (!paisLabel || typeof paisLabel !== 'string') return '';
  const t = paisLabel.trim();
  if (!t) return '';
  const byL = PAISES_COMUN.find(p => p.l === t);
  if (byL) return byL.v;
  const byV = PAISES_COMUN.find(p => p.v === t);
  return byV?.v ?? '';
}

export function paisCodeToLabel(code) {
  if (!code) return '';
  return PAISES_COMUN.find(p => p.v === code)?.l ?? '';
}

export function ciudadOptionsForPaisCode(paisCode) {
  if (paisCode === 'ES') return CIUDAD_OPTIONS_ES;
  if (!paisCode) return [];
  return CIUDAD_OPTIONS_OTROS[paisCode] ?? CIUDAD_OPTIONS_OTROS.OT;
}

export function localidadOptionsFor(paisCode, ciudadLabel) {
  if (!paisCode) return [];
  if (paisCode === 'ES') {
    if (ciudadLabel && LOCALIDADES_ES[ciudadLabel]) return LOCALIDADES_ES[ciudadLabel];
    return LOCALIDAD_DEFAULT_ES;
  }
  return LOCALIDAD_EXTRANJERO;
}

/** Si el valor guardado ya no está en la lista, se muestra como opción extra en el desplegable. */
export function optionsWithLegacy(opts, legacyValue) {
  const v = typeof legacyValue === 'string' ? legacyValue.trim() : '';
  if (!v || opts.includes(v)) return opts;
  return [v, ...opts];
}
